<button class="__btn" [attr.type]="typeButton" [disabled]="disabled" (click)="onClick($event)"
        fxLayoutGap="0.1rem"
        fxLayout="inline"
        fxLayoutAlign="center center">
  <i class="agi-file-pdf"></i>
  <span><ng-content></ng-content></span>
</button>
